var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVigyanVrikshTestSeries(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.icon-image-layer4{fill:none;stroke:currentcolor;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "icon-image-layer4",
    d: "M79.2,68.6c0,4.1,0.3,14.4,0.3,17.8c-7,0-12.9,0.5-19.7,2"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "icon-image-layer4",
    points: "51.3,91.8 43.9,65.3 2,65.3 9.3,91.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "icon-image-layer4",
    d: "M90.1,96.6c2.4-9.5,2.2-24.8,0.7-33.2c-0.7-4-3.4-7.3-7.1-8.9l-11.4-4.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "icon-image-layer4",
    d: "M72.3,49.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "icon-image-layer4",
    d: "M31.2,64.9c0.1-2.8,1.2-5.6,3.1-7.6c1.1-1.2,2.5-2.1,4.1-2.8l11.4-4.7"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "icon-image-layer4",
    d: "M44.3,26.5c0,0,21-0.7,25.7-9.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "icon-image-layer4",
    d: "M81,19.3c-0.4-1.5-1.1-3.4-2.2-5.3c-1.7-3.2-4.4-6.6-8.5-8.8c-5.2-2.8-11.4-2.8-16.8-0.5c-3.5,1.5-7.4,4.1-10.1,8.7c-1,1.7-1.9,3.8-2.5,6.1c-0.6,2.2,0.2,4.5,1.9,6c1.7,1.4,2,2.5,2.3,4.1l0,0l0,0c1.7,9.1,8.2,18.9,16,18.9c7.8,0,14.3-9.7,16-18.8c0.1-0.6,0.2-1.1,0.4-1.6c0.4-1,0.9-1.8,2.2-3.2c0.2-0.2,0.3-0.3,0.4-0.5C81.2,22.9,81.5,21,81,19.3z"
  })), /*#__PURE__*/React.createElement("line", {
    className: "icon-image-layer4",
    x1: 98,
    y1: 97,
    x2: 4.5,
    y2: 97
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVigyanVrikshTestSeries);
export default __webpack_public_path__ + "static/media/vigyan-vriksh-test-series.8b636400920758327ec7a96c2b609973.svg";
export { ForwardRef as ReactComponent };